var _circle, _path, _path2, _circle2, _circle3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLessThanTruckload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 38,
    fill: "#387",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.234 39.505v-15.08h3.996M40.261 36.46l-7.278-12.036H23.23M40.26 36.46v5.233m0-5.233H27.703m0 0V27.28m0 9.181H23.23V24.424M15.43 47.45v-7.897h17.03l4.377 3.996M23.898 51.065h13.226",
    stroke: "#387",
    strokeWidth: 1.429
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.172 51.017c.177-1.565.16-2.338.476-3.473 1.05-3.777 4.004-6.301 8.134-5.898 1.228.12 2.217.561 3.854.999M40.93 20.619h2.664m0 0h3.044v16.745M43.594 20.62v16.745m0 4.282v-4.282m3.044 8.849v-8.849m0 0h-3.044m3.044 0h3.045v14.557h12.845",
    stroke: "#387",
    strokeWidth: 1.429
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 19.281,
    cy: 50.352,
    r: 4.376,
    stroke: "#387",
    strokeWidth: 1.905
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 42.308,
    cy: 49.59,
    r: 5.137,
    stroke: "#387",
    strokeWidth: 1.905
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzYiIGhlaWdodD0iNzYiIHZpZXdCb3g9IjAgMCA3NiA3NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMzgiIGN5PSIzOCIgcj0iMzgiIGZpbGw9IiMzMzg4NzciIGZpbGwtb3BhY2l0eT0iMC4yIi8+CjxwYXRoIGQ9Ik0xOS4yMzQ0IDM5LjUwNDhWMjQuNDI0M0gyMy4yMzA1TTQwLjI2MTUgMzYuNDYwMkwzMi45ODI5IDI0LjQyNDNIMjMuMjMwNU00MC4yNjE1IDM2LjQ2MDJWNDEuNjkzMk00MC4yNjE1IDM2LjQ2MDJIMjcuNzAyM00yNy43MDIzIDM2LjQ2MDJWMjcuMjc4N00yNy43MDIzIDM2LjQ2MDJIMjMuMjMwNVYyNC40MjQzIiBzdHJva2U9IiMzMzg4NzciIHN0cm9rZS13aWR0aD0iMS40Mjg1NyIvPgo8cGF0aCBkPSJNMTUuNDI5NyA0Ny40NDk4VjM5LjU1MjdIMzIuNDYwN0wzNi44Mzc0IDQzLjU0ODgiIHN0cm9rZT0iIzMzODg3NyIgc3Ryb2tlLXdpZHRoPSIxLjQyODU3Ii8+CjxwYXRoIGQ9Ik0yMy44OTg0IDUxLjA2NDlIMzcuMTIzNiIgc3Ryb2tlPSIjMzM4ODc3IiBzdHJva2Utd2lkdGg9IjEuNDI4NTciLz4KPHBhdGggZD0iTTM0LjE3MTkgNTEuMDE3M0MzNC4zNDkxIDQ5LjQ1MjIgMzQuMzMyMiA0OC42Nzk1IDM0LjY0NzYgNDcuNTQ0NUMzNS42OTc0IDQzLjc2NjkgMzguNjUyMyA0MS4yNDMgNDIuNzgyNSA0MS42NDU2QzQ0LjAxMDQgNDEuNzY1MyA0NC45OTkgNDIuMjA3IDQ2LjYzNTkgNDIuNjQ0NiIgc3Ryb2tlPSIjMzM4ODc3IiBzdHJva2Utd2lkdGg9IjEuNDI4NTciLz4KPHBhdGggZD0iTTQwLjkyOTcgMjAuNjE4N0g0My41OTM4TTQzLjU5MzggMjAuNjE4N0g0Ni42Mzg0VjM3LjM2NDJNNDMuNTkzOCAyMC42MTg3VjM3LjM2NDJNNDMuNTkzOCA0MS42NDU3VjM3LjM2NDJNNDYuNjM4NCA0Ni4yMTI3VjM3LjM2NDJNNDYuNjM4NCAzNy4zNjQySDQzLjU5MzhNNDYuNjM4NCAzNy4zNjQySDQ5LjY4M1Y1MS45MjE0SDYyLjUyNzYiIHN0cm9rZT0iIzMzODg3NyIgc3Ryb2tlLXdpZHRoPSIxLjQyODU3Ii8+CjxjaXJjbGUgY3g9IjE5LjI4MTMiIGN5PSI1MC4zNTE2IiByPSI0LjM3NTc1IiBzdHJva2U9IiMzMzg4NzciIHN0cm9rZS13aWR0aD0iMS45MDQ3NiIvPgo8Y2lyY2xlIGN4PSI0Mi4zMDgiIGN5PSI0OS41OTAzIiByPSI1LjEzNjkxIiBzdHJva2U9IiMzMzg4NzciIHN0cm9rZS13aWR0aD0iMS45MDQ3NiIvPgo8L3N2Zz4K";
export { SvgLessThanTruckload as ReactComponent };